<template>
    <div class="px-0 pt-4">  <!-- Abdullah added this class  -->

        <!-- Abdullah commented this code  -->
        <!-- <div class="clearfix row bg-white mb-4 p-4">
            <div class="col-md-12 px-0">
                <h2 class="text-center mb-3">Create a new company using the wizard below.</h2>
                <p class="text-center" style="max-width: 700px; margin: 0 auto 1rem;">To on board your company in accordHRM, please complete the forms below and complete your enrollment. Once you have created the company, you will be able to add employees, create/update employee contracts, setup payroll/salary settings and run Payrun Cycles / Off Cycles regularly as per your accordHRM package.</p>
                <div class="process-flow mt-5">
                    <h6>Process Flow</h6>
                    <div class="row">
                        <div class="col-sm-2 rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card"><div class="process-flow-inner"><span><img v-bind:src="$api_url+'/images/create-company.png'"  class="img-fluid mr-3" height="40px" width="40px" /></span><span>Create<br/>Company</span></div></div>
                        <div class="col-sm-2 rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card col-half-offset"><div class="process-flow-inner"><span><img v-bind:src="$api_url+'/images/employees-contracts.png'"  class="img-fluid mr-3" height="40px" width="40px" /></span><span>Add Employees<br/>&amp; Contracts</span></div></div>
                        <div class="col-sm-2 rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card col-half-offset"><div class="process-flow-inner"><span><img v-bind:src="$api_url+'/images/pf-settings.png'"  class="img-fluid mr-3 dark-mode-icon" height="40px" width="40px" /><img v-bind:src="$api_url+'/images/pf-settings-active.png'"  class="img-fluid mr-3 light-mode-icon" height="40px" width="40px" /></span><span>Set up Payroll /<br/> Salary / PF Settings</span></div></div>
                        <div class="col-sm-2 rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card col-half-offset"><div class="process-flow-inner"><span><img v-bind:src="$api_url+'/images/run-batch-payroll.png'"  class="img-fluid mr-3" height="40px" width="40px" /></span><span>Run Batch<br/>Payroll (Payrun)</span></div></div>
                        <div class="col-sm-2 rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card col-half-offset"><div class="process-flow-inner"><span><img v-bind:src="$api_url+'/images/tax-card.png'"  class="img-fluid mr-3" height="40px" width="40px" /></span><span>Get Tax Card<br/>Payslips Challan</span></div></div>
                    </div>
                </div>
            </div>
        </div> -->

        <!-- Abdullah added this code  -->
         <div class="=row">
            <div class="ibox col-md-12 top_container_agent_wizerd">
                <div class="ibox-title dashboard_title">
                    <div class="row no-gutters">
                        <div class="col-sm-8 float-left mb-2">
                            <div class="title-text pt-3 table_text_color pb-3">Company Creation Wizard</div>
                            <span class="table_text_color pt-2 text_sixe_agent">To on board your company in ATLHR, please
                                complete the forms below and complete your enrollment. Once you have created the company,
                                you will be able to add employees, create/update employee contracts, setup payroll/salary
                                settings and run Payrun Cycles / Off Cycles regularly as per your atlHR package.</span>
                        </div>
                    </div>
                </div>
                <!-- <h2 class="text-center mb-3">Create a new company using the wizard below.</h2>
            <p class="text-center" style="max-width: 700px; margin: 0 auto 1rem;">To on board your company in ATLHR, please complete the forms below and complete your enrollment. Once you have created the company, you will be able to add employees, create/update employee contracts, setup payroll/salary settings and run Payrun Cycles / Off Cycles regularly as per your atlHR package.</p>
            <div class="process-flow mt-5">
                <h6>Process Flow</h6>
                <div class="row">
                    <div class="col-sm-2 rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card"><div class="process-flow-inner"><span><img v-bind:src="pageurl+'/public/images/create-company.png'"  class="img-fluid mr-3" height="40px" width="40px" /></span><span>Create<br/>Company</span></div></div>
                    <div class="col-sm-2 rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card col-half-offset"><div class="process-flow-inner"><span><img v-bind:src="pageurl+'/public/images/employees-contracts.png'"  class="img-fluid mr-3" height="40px" width="40px" /></span><span>Add Employees<br/>&amp; Contracts</span></div></div>
                    <div class="col-sm-2 rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card col-half-offset"><div class="process-flow-inner"><span><img v-bind:src="pageurl+'/public/images/pf-settings.png'"  class="img-fluid mr-3 dark-mode-icon" height="40px" width="40px" /><img v-bind:src="pageurl+'/public/images/pf-settings-active.png'"  class="img-fluid mr-3 light-mode-icon" height="40px" width="40px" /></span><span>Set up Payroll /<br/> Salary / PF Settings</span></div></div>
                    <div class="col-sm-2 rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card col-half-offset"><div class="process-flow-inner"><span><img v-bind:src="pageurl+'/public/images/run-batch-payroll.png'"  class="img-fluid mr-3" height="40px" width="40px" /></span><span>Run Batch<br/>Payroll (Payrun)</span></div></div>
                    <div class="col-sm-2 rounded process-flow-charts d-flex align-items-center justify-content-center py-4 card col-half-offset"><div class="process-flow-inner"><span><img v-bind:src="pageurl+'/public/images/tax-card.png'"  class="img-fluid mr-3" height="40px" width="40px" /></span><span>Get Tax Card<br/>Payslips Challan</span></div></div>
                </div>
            </div> -->
            </div>
        </div>
        <!-- Abdullah added this code upto here -->


        <div class="row px-3"> <!-- Abdullah added px-3 -->
            <div class="col-md-12 bg-white shadow-lg payrun-wizard-container ibox pb-5"> <!-- Abdullah added payrun-wizard-container ibox pb-5 -->
                <div :class="this.all_done">
                <form-wizard ref="wizard" color="#0060c9" @on-complete="onComplete" >  <!-- Abdullah chnaged color -->
                    <h2 class="py-2 mt-3 mb-4" slot="title">Company Creation Wizard</h2>

                    <!-- Abdullah commented this  -->
                    <!-- <tab-content title="Overview" lazy=true>
                        <company-overview  :flg="1" v-on:childToParent="getOverviewFlg" ></company-overview>

                    </tab-content> -->

                    <!-- Abdullah added this  -->
                    <tab-content title="Overview" :before-change="changeMessageflagBefore"
                        :after-change="changeMessageflag">

                        <div class="row justify-content-center">
                            <company-overview :pageurl="this.$api_url" :flg="1"
                                v-on:childToParent="getOverviewFlg"></company-overview>

                        </div>


                    </tab-content>

                    <!-- Abdullah commented this  -->
                    <!-- <tab-content title="Tax Info" lazy=true>
                        <company-taxinfo  :flg="1" v-on:childToParent="getTaxInfoFlg" v-if="company_id > 0"></company-taxinfo>

                    </tab-content> -->

                    <!-- Abdullah added this  -->
                    <tab-content title="Tax Info" :before-change="changeMessageflagBefore"
                        :after-change="changeMessageflag">
                        <div class="row justify-content-center">
                            <company-taxinfo :pageurl="this.$api_url" :flg="1" v-on:childToParent="getTaxInfoFlg"
                                v-if="company_id > 0"></company-taxinfo>
                        </div>

                    </tab-content>
                    <!-- Abdullah commented this  -->
                    <!-- <tab-content title="Departments" >

                        <template v-if="has_departments">
                            <all-departments  :flg="1" v-on:childToParent="getDepartmentsFlg"  v-if="company_id > 0" :key="c"></all-departments>
                        </template>
                        <template v-else>
                            <div class="card company-form-container" v-if="xdata.department_has">
                                <div class="card-body py-0">
                                    <div class="justify-content-center py-2 mb-3 border-bottom mx-n-custom"><div class="col-sm-6 px-3 company-form-box-title">Departments</div></div>
                                    <div class="deprtment-top-block border mt-4 mb-5 p-5">
                                        <h6 class="mb-4">Do you have Departments?</h6>
                                        <p>Please create departments of your company. Without departments you won't be able to add your employees. You can add / update / delete departments anytime later.</p>
                                        <b-button class="mr-2 w-auto px-4" type="button" variant="primary" @click="moveBack()">Go Back</b-button>
                                        <b-button class="yes-btn mr-2 w-auto px-4" type="button" variant="primary" @click="showHideBlock('show_department_options' , 'department_has')">Yes</b-button>
                                        <b-button class="ml-2 w-auto px-4" type="button" variant="primary" @click="moveNext()">No</b-button>
                                    </div>
                                </div>
                            </div>

                            <div class="card company-form-container" v-if="xdata.show_department_options">
                                <div class="card-body py-0">
                                    <div class="justify-content-center py-2 mb-3 border-bottom mx-n-custom"><div class="col-sm-6 px-3 company-form-box-title">Departments</div></div>
                                    <div class="deprtment-center-block mt-4 mb-5">
                                        <p class="text-center">Below we have suggested some Departments names for you. You can either choose multiple Department names from the list or you can choose 'I will add my own Departments to add all your Departments by yourself.</p>
                                        <div class="deprtment-center-block-inner px-5 py-3">
                                            <b-form-group >
                                                <b-form-checkbox-group
                                                    v-model="selected_sugg_departments"
                                                    :options="sugg_departments"
                                                    plain @change="setSelectedSuggDepartments()"
                                                    stacked>
                                                </b-form-checkbox-group>
                                            </b-form-group>

                                            <div class="department-custom-checkbox border border-dashed px-3 py-2">
                                            <b-form-checkbox @change='flushSelectedSuggDepartments()'
                                                v-model="flg_own_departments" value="true" unchecked-value="false">I will add my own departments</b-form-checkbox>
                                            </div>

                                            <b-button type="button" class="mt-3 w-100" variant="success" @click="saveOwnDepartments()">Submit</b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="" v-if="xdata.department_options">
                                <all-departments  :flg="1" v-on:childToParent="getDepartmentsFlg"  v-if="company_id > 0" :key="c"></all-departments>
                            </div>
                        </template>






                    </tab-content> -->

                    <!-- Abdullah added this  -->
                    <tab-content title="Departments" :before-change="changeMessageflagBefore"
                        :after-change="changeMessageflag">
                        <div class="clearfix row form-btn-container rounded mb-4 ">

                            <div class="col-md-4 pl-0"><b-button class="custom-wizard-btn" type="button"
                                    variant="primary" @click="moveBack()"><b-icon icon="chevron-left" rotate="0"
                                        class="mt-n1" scale="1"></b-icon> Back</b-button></div>
                            <div class="col-md-4 text-center custom-wizard-title">Departments</div>
                            <div class="col-md-4 pr-0 text-right"><b-button type="button" variant="primary"
                                    @click="moveNext('joiner')">Skip <b-icon icon="chevron-right" rotate="0"
                                        class="mt-n1" scale="1"></b-icon></b-button></div>
                        </div>
                        <div class="">
                            <template v-if="has_departments">
                                <all-departments :pageurl="this.$api_url" :flg="1" v-on:childToParent="getDepartmentsFlg"
                                    v-if="company_id > 0" :key="c"></all-departments>
                            </template>
                            <template v-else>
                                <div class="card border-0 no-shadow" v-if="xdata.department_has">
                                    <div class="card-body py-0">
                                        <div class="deprtment-top-block mt-4 mb-5 p-5">
                                            <h6 class="mb-4">Do you have Departments?</h6>
                                            <p>Please create departments of your company. Without departments you won't
                                                be
                                                able to add your employees. You can add / update / delete departments
                                                anytime later.</p>
                                            <b-button class="mr-2 w-auto px-4 d-none" type="button" variant="primary"
                                                @click="moveBack()">Go Back</b-button>
                                            <b-button class="yes-btn mr-2 w-auto px-4" type="button" variant="primary"
                                                @click="showHideBlock('show_department_options', 'department_has')">Yes</b-button>
                                            <b-button class="ml-2 w-auto px-4" type="button" variant="primary"
                                                @click="moveNext()">No</b-button>
                                        </div>
                                    </div>
                                </div>

                                <div class="card border-0 no-shadow" v-if="xdata.show_department_options">
                                    <div class="card-body py-0">
                                        <div class="deprtment-center-block mt-4 mb-5">
                                            <p class="text-center">Below we have suggested some Departments names for
                                                you.
                                                You can either choose multiple Department names from the list or you can
                                                choose 'I will add my own Departments to add all your Departments by
                                                yourself.</p>
                                            <div class="deprtment-center-block-inner px-5 py-3">
                                                <b-form-group>
                                                    <b-form-checkbox-group v-model="selected_sugg_departments"
                                                        :options="sugg_departments" plain
                                                        @change="setSelectedSuggDepartments()" stacked>
                                                    </b-form-checkbox-group>
                                                </b-form-group>

                                                <div class="department-custom-checkbox border border-dashed px-3 py-2">
                                                    <b-form-checkbox @change='flushSelectedSuggDepartments()'
                                                        v-model="flg_own_departments" value="true"
                                                        unchecked-value="false">I
                                                        will add my own departments</b-form-checkbox>
                                                </div>
                                                <div class="btn-wrapper text-center pt-5">
                                                    <b-button type="button" class="" variant="primary" @click="saveOwnDepartments()">Submit</b-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="" v-if="xdata.department_options">
                                    <all-departments :pageurl="this.$api_url" :flg="1"
                                        v-on:childToParent="getDepartmentsFlg" v-if="company_id > 0"
                                        :key="c"></all-departments>
                                </div>
                            </template>
                        </div>
                    </tab-content>

                    <!-- Abdullah commented this  -->
                    <!-- <tab-content title="Job Positions" >

                        <template v-if="has_jobpositions">
                            <all-jobpositions  :flg="1" v-on:childToParent="getJobpositionsFlg" v-if="company_id > 0" :key="c"></all-jobpositions>
                        </template>
                        <template v-else>
                            <div class="card company-form-container" v-if="xdata.jobposition_has">
                                <div class="card-body py-0">
                                    <div class="justify-content-center py-2 mb-3 border-bottom mx-n-custom"><div class="col-sm-6 px-3 company-form-box-title">Job Positions</div></div>
                                    <div class="deprtment-top-block border mt-4 mb-5 p-5">
                                        <h6 class="mb-4">Do you have Job Positions?</h6>
                                        <p>Please create job positions of your company. Without job positions you won't be able to add your employees. You can add / update / delete job positions anytime later.</p>
                                        <b-button class="mr-2 w-auto px-4" type="button" variant="primary" @click="moveBack()">Go Back</b-button>
                                        <b-button class="yes-btn mr-2 w-auto px-4" type="button" variant="primary" @click="showHideBlock('show_jobposition_options' , 'jobposition_has')">Yes</b-button>
                                        <b-button class="ml-2 w-auto px-4" type="button" variant="primary" @click="moveNext()">No</b-button>

                                    </div>
                                </div>
                            </div>

                            <div class="card company-form-container" v-if="xdata.show_jobposition_options">
                                <div class="card-body py-0">
                                    <div class="justify-content-center py-2 mb-3 border-bottom mx-n-custom"><div class="col-sm-6 px-3 company-form-box-title">Job Positions</div></div>
                                    <div class="deprtment-center-block mt-4 mb-5">
                                        <p class="text-center">Below we have suggested some job positions names for you. You can either choose multiple job positions names from the list or you can choose 'I will add my own job positions' to add all your job positions by yourself.</p>
                                        <div class="deprtment-center-block-inner px-5 py-3">
                                            <b-form-group >
                                                <b-form-checkbox-group
                                                    v-model="selected_sugg_jobpositions"
                                                    :options="sugg_jobpositions"
                                                    plain @change="setSelectedSuggJobpositions()"
                                                    stacked>
                                                </b-form-checkbox-group>
                                            </b-form-group>

                                            <div class="department-custom-checkbox border border-dashed px-3 py-2">
                                            <b-form-checkbox @change='flushSelectedSuggJobpositions()'
                                                v-model="flg_own_jobpositions" value="true" unchecked-value="false">I will add my own Job Position</b-form-checkbox>
                                            </div>

                                            <b-button type="button" class="mt-3 w-100" variant="success" @click="saveOwnJobpositions()">Submit</b-button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="" v-if="xdata.jobposition_options">
                                <all-jobpositions  :flg="1" v-on:childToParent="getJobpositionsFlg" v-if="company_id > 0"  :key="c"></all-jobpositions>
                            </div>
                        </template>



                    </tab-content> -->
                    <!-- Abdullah added this  -->

                      <tab-content title="Job Positions" :before-change="changeMessageflagBefore"
                            :after-change="changeMessageflag">
                            <div class="clearfix row form-btn-container rounded mb-4 ">

                                <div class="col-md-4 pl-0"><b-button class="custom-wizard-btn" type="button"
                                        variant="primary" @click="moveBack()"><b-icon icon="chevron-left" rotate="0"
                                            class="mt-n1" scale="1"></b-icon> Back</b-button></div>
                                <div class="col-md-4 text-center custom-wizard-title">Job Positions</div>
                                <div class="col-md-4 pr-0 text-right"><b-button type="button" variant="primary"
                                        @click="moveNext('joiner')">Skip <b-icon icon="chevron-right" rotate="0"
                                            class="mt-n1" scale="1"></b-icon></b-button></div>
                            </div>
                            <div class="">
                                <template v-if="has_jobpositions">
                                    <all-jobpositions :pageurl="this.$api_url" :flg="1"
                                        v-on:childToParent="getJobpositionsFlg" v-if="company_id > 0"
                                        :key="c"></all-jobpositions>
                                </template>
                                <template v-else>
                                    <div class="card border-0 no-shadow" v-if="xdata.jobposition_has">
                                        <div class="card-body py-0">
                                            <div class="deprtment-top-block mt-4 mb-5 p-5">
                                                <h6 class="mb-4">Do you have Job Positions?</h6>
                                                <p>Please create job positions of your company. Without job positions you
                                                    won't
                                                    be able to add your employees. You can add / update / delete job
                                                    positions
                                                    anytime later.</p>
                                                <b-button class="mr-2 w-auto px-4 d-none" type="button" variant="primary"
                                                    @click="moveBack()">Go Back</b-button>
                                                <b-button class="yes-btn mr-2 w-auto px-4" type="button" variant="primary"
                                                    @click="showHideBlock('show_jobposition_options', 'jobposition_has')">Yes</b-button>
                                                <b-button class="ml-2 w-auto px-4" type="button" variant="primary"
                                                    @click="moveNext()">No</b-button>

                                            </div>
                                        </div>
                                    </div>

                                    <div class="card border-0 no-shadow" v-if="xdata.show_jobposition_options">
                                        <div class="card-body py-0">
                                            <div class="deprtment-center-block mt-4 mb-5">
                                                <p class="text-center">Below we have suggested some job positions names for
                                                    you.
                                                    You can either choose multiple job positions names from the list or you
                                                    can
                                                    choose 'I will add my own job positions' to add all your job positions
                                                    by
                                                    yourself.</p>
                                                <div class="deprtment-center-block-inner px-5 py-3">
                                                    <b-form-group>
                                                        <b-form-checkbox-group v-model="selected_sugg_jobpositions"
                                                            :options="sugg_jobpositions" plain
                                                            @change="setSelectedSuggJobpositions()" stacked>
                                                        </b-form-checkbox-group>
                                                    </b-form-group>

                                                    <div class="department-custom-checkbox border border-dashed px-3 py-2">
                                                        <b-form-checkbox @change='flushSelectedSuggJobpositions()'
                                                            v-model="flg_own_jobpositions" value="true"
                                                            unchecked-value="false">I will add my own Job
                                                            Position</b-form-checkbox>
                                                    </div>

                                                    <div class="btn-wrapper text-center pt-5">
                                                        <b-button type="button" class="" variant="primary" @click="saveOwnJobpositions()">Submit</b-button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="" v-if="xdata.jobposition_options">
                                        <all-jobpositions :pageurl="this.$api_url" :flg="1"
                                            v-on:childToParent="getJobpositionsFlg" v-if="company_id > 0"
                                            :key="c"></all-jobpositions>
                                    </div>
                                </template>
                            </div>





                        </tab-content>

                        <!-- Abdullah commented this  -->
                    <!-- <tab-content title="Work Locations">

                        <template v-if="has_branches">
                            <all-branches  :flg="1" v-on:childToParent="getBranchesFlg"  v-if="company_id > 0"></all-branches>
                        </template>
                        <template v-else>
                            <div class="card company-form-container" v-if="xdata.branch_has">
                                <div class="card-body py-0">
                                    <div class="justify-content-center py-2 mb-3 border-bottom mx-n-custom"><div class="col-sm-6 px-3 company-form-box-title">Work Locations</div></div>
                                    <div class="deprtment-top-block border mt-4 mb-5 p-5">
                                        <h6 class="mb-4">Do you have Work Locations?</h6>
                                        <p>You can add your work locations here and assign your employees under separate work locations when you add them.</p>
                                        <b-button class="mr-2 w-auto px-4" type="button" variant="primary" @click="moveBack()">Go Back</b-button>
                                        <b-button class="yes-btn mr-2 w-auto px-4" type="button" variant="primary" @click="showHideBlock('branch_options' , 'branch_has')">Yes</b-button>
                                        <b-button class="ml-2 w-auto px-4" type="button" variant="primary" @click="moveNext()">No</b-button>
                                    </div>
                                </div>
                            </div>

                            <div class="" v-if="xdata.branch_options">
                                <all-branches  :flg="1" v-on:childToParent="getBranchesFlg"  v-if="company_id > 0"></all-branches>
                            </div>
                        </template>



                    </tab-content> -->

                     <!-- Abdullah commented this  -->
                    <!-- <tab-content title="Tax Settings">
                        <company-taxsettings  :flg="1" v-on:childToParent="getTaxSettingsFlg"  v-if="company_id > 0"></company-taxsettings>

                    </tab-content> -->
                        <!-- Abdullah commented this  -->
                    <!-- <tab-content title="Salary Settings">
                        <company-settings  :flg="1" v-on:childToParent="getCompanySettingsFlg"  v-if="company_id > 0"></company-settings>

                    </tab-content> -->

                    <!-- Abdullah added this code  -->
                    <tab-content title="Work Locations" :before-change="changeMessageflagBefore"
                            :after-change="changeMessageflag">
                            <div class="clearfix row form-btn-container rounded mb-4 ">

                                <div class="col-md-4 pl-0"><b-button class="custom-wizard-btn" type="button"
                                        variant="primary" @click="moveBack()"><b-icon icon="chevron-left" rotate="0"
                                            class="mt-n1" scale="1"></b-icon> Back</b-button></div>
                                <div class="col-md-4 text-center custom-wizard-title">Work Locations</div>
                                <div class="col-md-4 pr-0 text-right"><b-button type="button" variant="primary"
                                        @click="moveNext('joiner')">Skip <b-icon icon="chevron-right" rotate="0"
                                            class="mt-n1" scale="1"></b-icon></b-button></div>
                            </div>
                            <div class="">
                                <template v-if="has_branches">
                                    <all-branches :pageurl="this.$api_url" :flg="1" v-on:childToParent="getBranchesFlg"
                                        v-if="company_id > 0"></all-branches>
                                </template>
                                <template v-else>
                                    <div class="card border-0 no-shadow" v-if="xdata.branch_has">
                                        <div class="card-body py-0">
                                            <div class="deprtment-top-block mt-4 mb-5 p-5">
                                                <h6 class="mb-4">Do you have Work Locations?</h6>
                                                <p>You can add your work locations here and assign your employees under
                                                    separate
                                                    work locations when you add them.</p>
                                                <b-button class="mr-2 w-auto px-4 d-none" type="button" variant="primary"
                                                    @click="moveBack()">Go Back</b-button>
                                                <b-button class="yes-btn mr-2 w-auto px-4" type="button" variant="primary"
                                                    @click="showHideBlock('branch_options', 'branch_has')">Yes</b-button>
                                                <b-button class="ml-2 w-auto px-4" type="button" variant="primary"
                                                    @click="moveNext()">No</b-button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="" v-if="xdata.branch_options">
                                        <all-branches :pageurl="this.$api_url" :flg="1" v-on:childToParent="getBranchesFlg"
                                            v-if="company_id > 0"></all-branches>
                                    </div>
                                </template>

                            </div>



                        </tab-content>

                        <tab-content title="Tax Settings" :before-change="changeMessageflagBefore"
                            :after-change="changeMessageflag">
                            <div class="clearfix row form-btn-container rounded mb-4 ">

                                <div class="col-md-4 pl-0"><b-button class="custom-wizard-btn" type="button"
                                        variant="primary" @click="moveBack()"><b-icon icon="chevron-left" rotate="0"
                                            class="mt-n1" scale="1"></b-icon> Back</b-button></div>
                                <div class="col-md-4 text-center custom-wizard-title">Tax Settings</div>
                                <div class="col-md-4 pr-0 text-right"><b-button type="button" variant="primary"
                                        @click="moveNext('joiner')">Skip <b-icon icon="chevron-right" rotate="0"
                                            class="mt-n1" scale="1"></b-icon></b-button></div>
                            </div>
                            <div class="">
                                <company-taxsettings :pageurl="this.$api_url" :flg="1" v-on:childToParent="getTaxSettingsFlg"
                                    v-if="company_id > 0"></company-taxsettings>
                            </div>


                        </tab-content>

                        <tab-content title="Salary Settings" :before-change="changeMessageflagBefore"
                            :after-change="changeMessageflag">
                            <div class="clearfix row form-btn-container rounded mb-4 ">

                                <div class="col-md-4 pl-0"><b-button class="custom-wizard-btn" type="button"
                                        variant="primary" @click="moveBack()"><b-icon icon="chevron-left" rotate="0"
                                            class="mt-n1" scale="1"></b-icon> Back</b-button></div>
                                <div class="col-md-4 text-center custom-wizard-title">Salary Settings</div>
                                <div class="col-md-4 pr-0 text-right"><b-button type="button" variant="primary"
                                        @click="moveNext('joiner')">Skip <b-icon icon="chevron-right" rotate="0"
                                            class="mt-n1" scale="1"></b-icon></b-button></div>
                            </div>
                            <div class="">
                                <company-settings :pageurl="this.$api_url" :flg="1"
                                    v-on:childToParent="getCompanySettingsFlg" v-if="company_id > 0"></company-settings>
                            </div>

                        </tab-content>



                    <!--<tab-content title="PF Settings" :before-change="beforeTabSwitch">
                        <div class="clearfix">
                            <company-pf-settings  :flg="1" v-on:childToParent="getPFSettingsFlg" v-if="company_id > 0"></company-pf-settings>
                        </div>
                    </tab-content>-->

                    <!-- <tab-content title="Success">
                        <div class="clearfix">
                            <div class="clearfix company-form-container rounded mt-4 pb-5 mx-auto px-3">
                                <div class="clearfix row py-2 mb-2 border-bottom">
                                    <div class="col-sm-6 px-3 company-form-box-title">Success</div>
                                </div>
                                <div class="row px-5 ml-auto mr-auto bg-white mt-4 position-relative" style="width: 90%;">
                                    <svg id="m-check-mark" class="custom-success-arrow" width="100px" height="100px" viewBox="0 0 245 173" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                        <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-opacity="1">
                                            <polyline id="checkmark" stroke="rgba(67, 160, 71, 1)" stroke-width="15" points="5.640625 83.7607422 83.2539062 161.663086 238.97168 6.11328125"></polyline>
                                        </g>
                                    </svg>


                                    <template>
                                        <svg width="200" height="200" style="background: transparent;" id="custom-success-circle-noanimation" class="ml-auto mr-auto d-block mt-5">
                                            <circle class="outer" cx="100" cy="100" r="85" transform="rotate(-90, 95, 95)"></circle>
                                        </svg>
                                        <h5 class="text-center w-100 my-3">All Done</h5>
                                        <p class="text-center">Congratulations! You are completed with on boarding your company on accordHRM. Before you start generating Payroll for your company you will need to set up your company's Payroll Settings / Salary Settings / Provident Fund Settings and then add employees accordingly.</p>

                                    </template>

                                    <a :href="this.$api_url + '/company/info'" class="btn btn-primary w-100 mb-3">Go to Payroll Settings / Salary Settings / Provident Fund Settings</a>
                                    <a :href="this.$api_url + '/employee'" class="btn btn-primary w-100 mb-4">Go to Employee Management</a>
                                    <a href="#" class="btn btn-primary w-100 mb-4" @click="create_new()">Create Another Company</a>
                                </div>
                            </div>
                        </div>
                    </tab-content> -->
                        <tab-content title="Success" :before-change="changeMessageflagBefore"
                            :after-change="changeMessageflag">
                            <div class="clearfix row form-btn-container rounded mb-4 ">

                                <div class="col-md-4 pl-0"><b-button class="custom-wizard-btn" type="button"
                                        variant="primary" @click="moveBack()"><b-icon icon="chevron-left" rotate="0"
                                            class="mt-n1" scale="1"></b-icon> Back</b-button></div>
                                <div class="col-md-4 text-center custom-wizard-title">Success</div>
                            </div>
                            <div class="">
                                <div class="clearfix">
                                <div class="clearfix rounded mt-4 pb-5 mx-auto px-3">
                                    <div class="row px-5 ml-auto mr-auto bg-white mt-4 position-relative"
                                        style="width: 90%;">
                                        <svg id="m-check-mark" class="custom-success-arrow" width="100px" height="100px"
                                            viewBox="0 0 245 173" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                            xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                                                stroke-opacity="1">
                                                <polyline id="checkmark" stroke="rgba(67, 160, 71, 1)" stroke-width="15"
                                                    points="5.640625 83.7607422 83.2539062 161.663086 238.97168 6.11328125">
                                                </polyline>
                                            </g>
                                        </svg>


                                        <template>
                                            <svg width="200" height="200" style="background: transparent;"
                                                id="custom-success-circle-noanimation" class="ml-auto mr-auto d-block mt-5">
                                                <circle class="outer" cx="100" cy="100" r="85"
                                                    transform="rotate(-90, 95, 95)"></circle>
                                            </svg>
                                            <h5 class="text-center w-100 my-3">All Done</h5>
                                            <p class="text-center">Congratulations! You are completed with on boarding your
                                                company on ATLHR. Before you start generating Payroll for your company you
                                                will need to set up your company's Payroll Settings / Salary Settings /
                                                Provident Fund Settings and then add employees accordingly.</p>

                                        </template>

                                        <a :href="this.$api_url + '/company/info'" class="btn btn-primary w-100 mb-3">Go to
                                            Payroll Settings / Salary Settings / Provident Fund Settings</a>
                                        <a :href="this.$api_url + '/employee'" class="btn btn-primary w-100 mb-4">Go to
                                            Employee Management</a>
                                        <a href="#" class="btn btn-primary w-100 mb-4" @click="create_new()">Create Another
                                            Company</a>
                                    </div>
                                </div>
                            </div>
                            </div>

                        </tab-content>
                       <!-- Abdullah added this code  upto this-->

                    <template slot="footer" />
                </form-wizard>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import myUpload from 'vue-image-crop-upload';

    import {FormWizard, TabContent} from 'vue-form-wizard'
    import 'vue-form-wizard/dist/vue-form-wizard.min.css'

    /*import CompanyOverview from './CompanyOverview';
    import CompanyTaxInfo from './CompanyTaxInfo';
    import AllDepartments from './AllDepartments';
    import AllJobpositions from './AllJobpositions';
    import AllBranches from './AllBranches';*/

    export default{

        mounted() {

        },
        props: ['pf_enabled'],
        components: {'my-upload': myUpload, },
        components: {
            FormWizard,  TabContent,
            /*CompanyOverview,CompanyTaxInfo, AllDepartments, AllJobpositions, AllBranches*/
        },
        data(){

            return {

                c : 0,

                cu:window.location.href,
                ce:false,
                company_id : 0,
                completion : 0,
                all_done : '',

                jp_flg : 0, // This variable is for reloading jobposition component

                overview_flg:0,
                taxinfo_flg:0,
                departments_flg:0,
                jobpositions_flg:0,
                branches_flg:0,

                has_departments : false,
                has_jobpositions : false,
                has_branches : false,

                logophoto:null,
                logosrc:null,
                isHovered: false,

                successmsg:false,
                warningmsg:false,
                dangermsg:false,

                xdata : {
                        show_department_options : false, department_has : true,  department_options : false,
                        show_jobposition_options : false, jobposition_has : true,  jobposition_options : false,
                        show_branch_options : false, branch_has : true,  branch_options : false,
                    },

                selected_sugg_departments: [], // Must be an array reference!
                sugg_departments: [
                    { text: 'Human resource', value: 'Human resource' },
                    { text: 'Finance & accounts', value: 'Finance & accounts' },
                    { text: 'Sales & marketing', value: 'Sales & marketing' },
                    { text: 'Operations', value: 'Operations' },
                    { text: 'Administrations', value: 'Administrations' },
                    { text: 'Procurement', value: 'Procurement' },
                    { text: 'Information Technology', value: 'Information technology' },
                    { text: 'Internal audit', value: 'Internal audit' },
                ],
                flg_own_departments : false,

                selected_sugg_jobpositions: [], // Must be an array reference!
                sugg_jobpositions: [
                    { text: 'Managing director', value: 'Managing director' },
                    { text: 'Director', value: 'Director' },
                    { text: 'General manager', value: 'General manager' },
                    { text: 'Deputy general manager', value: 'Deputy general manager' },
                    { text: 'Assistant general manager', value: 'Assistant general manager' },
                    { text: 'Senior manager', value: 'Senior manager' },
                    { text: 'Manager', value: 'Manager' },
                    { text: 'Deputy manager', value: 'Deputy manager' },
                    { text: 'Assistant manager', value: 'Assistant manager' },
                    { text: 'Senior officer', value: 'Senior officer' },
                    { text: 'Officer', value: 'Officer' },
                    { text: 'Senior executive', value: 'Senior executive' },
                    { text: 'Executive', value: 'Executive' },
                ],
                flg_own_jobpositions : false,

            }
        },
        methods:{
            getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;
                }.bind(this));
            },

            // AbdullahALC added this

            changeMessageflagBefore: function () {
                return true;
            },

            changeMessageflag: function () {

                return true;
            },

            // AbdullahALC added this upto this
            showHideBlock: function(x , y){
                this.c++;
                this.xdata[y] = false;
                this.xdata[x] = true;
            },
            moveNext: function(){
                this.c++;
                this.$refs.wizard.nextTab();
            },
            moveBack: function(){
                this.c++;
                this.$refs.wizard.prevTab();
            },
            moveFinish: function(){
                this.$refs.wizard.activateAll();
                //this.$refs.wizard.nextTab();
                this.$refs.wizard.changeTab(0,7);
                this.onComplete();
            },
            onComplete: function(){

                this.$bvToast.toast('Yay. Done!', {
                                            title: `All steps completed`,
                                            variant: 'success',
                                            solid: true
                                        });


                this.all_done = 'trz_complete';
                //location.reload();
            },
            beforeTabSwitch: function(){
                let custom_success_circle = document.getElementById('custom-success-circle-noanimation');
                custom_success_circle.classList.add('custom-success-circle');
                let custom_success_arrow = document.getElementById('m-check-mark');
                custom_success_arrow.classList.add('custom-success-arrow-animation');
                return true;
            },



            flushSelectedSuggDepartments: function()
            {

                if(this.flg_own_departments == "true")
                {
                    this.selected_sugg_departments = [];
                }

            },
            setSelectedSuggDepartments: function()
            {

                this.flg_own_departments = "false";
            },
            saveOwnDepartments: function(){

                if(this.selected_sugg_departments != '')
                {
                    let currentObj = this;
                    let formData = new FormData();
                    formData.append('nm', this.selected_sugg_departments);

                    axios.post(this.$api_url+'/department/mass', formData)
                                .then(function (response)
                                {
                                    this.successmsg = 'Saved!';
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                    this.c++;

                                }.bind(this))
                                .catch(function (error)
                                {
                                    //alert(error.response.data.errors);
                                    currentObj.serverError(error);
                                    currentObj.errormsg = error.response.data.errors;
                                });
                }
                this.showHideBlock('department_options' , 'show_department_options');

            },

            /////////////

            flushSelectedSuggJobpositions: function()
            {

                if(this.flg_own_jobpositions == "true")
                {
                    this.selected_sugg_jobpositions = [];
                }

            },
            setSelectedSuggJobpositions: function()
            {

                this.flg_own_jobpositions = "false";
            },
            saveOwnJobpositions: function(){

                if(this.selected_sugg_jobpositions != '')
                {
                    let currentObj = this;
                    let formData = new FormData();
                    formData.append('nm', this.selected_sugg_jobpositions);

                    axios.post(this.$api_url+'/jobposition/mass', formData)
                                .then(function (response)
                                {
                                    this.successmsg = 'Saved!';
                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                    this.c++;

                                }.bind(this))
                                .catch(function (error)
                                {
                                    //alert(error.response.data.errors);
                                    currentObj.serverError(error);
                                    currentObj.errormsg = error.response.data.errors;
                                });
                }
                this.showHideBlock('jobposition_options' , 'show_jobposition_options');

            },




            handleHover(hovered) {
                this.isHovered = hovered
            },
            getLogo:function()
            {
                let currentObj = this;
                if(this.company_id > 0)
                {
                    axios.get(this.$api_url+'/company/logo' , {
                            params: {
                                //
                            }
                        }).then(function(response){
                            this.logosrc = this.$api_url+'/images/company/' + response.data;

                        }.bind(this)).catch(function (error){currentObj.serverError(error);});
                }


            },

            checkPFEnabled:function()
            {
                let currentObj = this;
                if(this.company_id > 0)
                {
                    axios.get(this.$api_url+'/ispfactive/'+this.company_id , {
                            params: {
                                //
                            }
                        }).then(function(response){
                            this.pf_enabled = (response.data.pf_enabled == '1') ? 1: 0;

                        }.bind(this)).catch(function (error){currentObj.serverError(error);});
                }


            },

            showlogouploader:function() {
                document.getElementById('logofile').click();
            },
            uploadlogo:function(event) {
                if(!this.checkNet()) return false;
                let currentObj = this;
                // this function upload the logo
                this.logophoto = event.target.files[0];

                const data = new FormData();
                data.append('company_logo', this.logophoto);

                axios.post(this.$api_url+"/company/logo", data).
                    then(function (response){
                        this.logosrc = this.$api_url+'/images/company/' + response.data;

                    }.bind(this)).catch(function (error){currentObj.serverError(error);});


            },
            // this function reload job positions component to get latest departent
            reloadJobPositions:function(event) {
                this.jp_flg += 1;
            },
            checkDepartmentJobPositionBranch : function()
            {

                let currentObj = this;
                if(this.company_id > 0)
                {
                    axios.get(this.$api_url+'/check/department/jobPosition/branch/' , {
                            params: {
                                //
                            }
                        }).then(function(response){
                            console.log(response);

                            if(response.data.no_of_department > 0) this.has_departments = true;
                            if(response.data.no_of_jobposition > 0) this.has_jobpositions = true;
                            if(response.data.no_of_branch > 0) this.has_branches = true;

                        }.bind(this)).catch(function (error){currentObj.serverError(error);});
                }


            },
            getOverviewFlg (value) {

                console.log(value);

                this.company_id = value.company_id;
                this.overview_flg = value.flg;
                this.successmsg = value.successmsg,
                this.warningmsg = value.warningmsg,
                this.dangermsg = value.dangermsg,
                this.getLogo();
                this.computeCompletion();
                this.checkPFEnabled();

                this.checkDepartmentJobPositionBranch();

                if(value.move_next)
                    this.moveNext();

                if(value.finish)
                    this.moveFinish();
            },
            getTaxInfoFlg (value) {
                /*this.taxinfo_flg = value.flg;
                this.successmsg = value.successmsg,
                this.warningmsg = value.warningmsg,
                this.dangermsg = value.dangermsg,
                this.computeCompletion();*/

                if(value.move_back)
                    this.$refs.wizard.prevTab();
                else if(value.move_next)
                    this.$refs.wizard.nextTab();
                else if(value.finish)
                    this.moveFinish();
            },
            getDepartmentsFlg (value) {
                this.department_options = true;

                this.departments_flg = value.flg;
                this.successmsg = value.successmsg,
                this.warningmsg = value.warningmsg,
                this.dangermsg = value.dangermsg,
                this.computeCompletion();

                if(value.move_back)
                    this.$refs.wizard.prevTab();
                else if(value.move_next)
                    this.$refs.wizard.nextTab();
                else if(value.finish)
                    this.moveFinish();
            },
            getJobpositionsFlg (value) {
                this.jobposition_options = true;

                this.jobpositions_flg = value.flg;
                this.successmsg = value.successmsg,
                this.warningmsg = value.warningmsg,
                this.dangermsg = value.dangermsg,
                this.computeCompletion();

                if(value.move_back)
                    this.$refs.wizard.prevTab();
                else if(value.move_next)
                    this.$refs.wizard.nextTab();
                else if(value.finish)
                    this.moveFinish();
            },
            getBranchesFlg (value) {
                this.branches_flg = value.flg;
                this.successmsg = value.successmsg,
                this.warningmsg = value.warningmsg,
                this.dangermsg = value.dangermsg,
                this.computeCompletion();

                if(value.move_back)
                    this.$refs.wizard.prevTab();
                else if(value.move_next)
                    this.$refs.wizard.nextTab();
                else if(value.finish)
                    this.moveFinish();
            },
            getTaxSettingsFlg(value){
                if(value.move_back)
                    this.$refs.wizard.prevTab();
                else if(value.move_next)
                    this.$refs.wizard.nextTab();
                else if(value.finish)
                    this.moveFinish();
            },
            getCompanySettingsFlg (value){
                if(value.move_back)
                    this.$refs.wizard.prevTab();
                else if(value.move_next)
                    this.$refs.wizard.nextTab();
                else if(value.finish)
                    this.moveFinish();
            },
            getPFSettingsFlg (value){

                if(value.move_back)
                    this.$refs.wizard.prevTab();
                else if(value.move_next)
                {
                    this.$refs.wizard.nextTab();
                    this.all_done = 'trz_complete';
                }
                else if(value.finish)
                {
                    this.moveFinish();
                    this.all_done = 'trz_complete';
                }
            },
            computeCompletion()
            {
                this.completion = (this.overview_flg + this.taxinfo_flg + this.departments_flg + this.jobpositions_flg + this.branches_flg) * 20;
            },
            create_new : function()
            {
                let formData = new FormData();
                axios.post(this.$api_url+'/flush/company/session', formData)
                                .then(function (response){

                    location.reload();
                })
            }
        },
        created: function(){
            this.getAcl();
            if(this.company_id > 0)
                this.$refs.wizard.activateAll();
        }
    }
</script>


<style>
    .wizard-btn { display:none ! important }
    .vue-form-wizard.md .wizard-icon-circle {
    	width: 42px;
    	height: 42px;
    	font-size: 29px;
    }
</style>
